import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.observer = new MutationObserver(mutations => this.reloadWhenSubscribed(mutations))
    this.observer.observe(this.element, { subtree: true, attributeFilter: ["connected"] })
  }

  disconnect() {
    this.observer.disconnect()
  }

  reloadWhenSubscribed(mutations) {
    if (mutations.some(mutation => mutation.target.hasAttribute("connected"))) this.element.reload()
  }

  keepSubscription(event) {
    const source = event.detail.newFrame.querySelector("turbo-cable-stream-source")

    if (source && this.subscribedTo(source)) event.detail.render = () => {}
  }

  subscribedTo(source) {
    const signedStreamName = source.getAttribute("signed-stream-name")

    return this.element.querySelector(`turbo-cable-stream-source[connected][signed-stream-name="${signedStreamName}"]`)
  }
}
